var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#3B5998"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1797_28126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 3.66663C7.39758 3.66663 3.66675 7.39746 3.66675 12C3.66675 16.1591 6.71425 19.6066 10.6984 20.2325V14.4083H8.58175V12H10.6984V10.1641C10.6984 8.07579 11.9417 6.92246 13.8459 6.92246C14.7576 6.92246 15.7109 7.08496 15.7109 7.08496V9.13496H14.6609C13.6251 9.13496 13.3026 9.77746 13.3026 10.4366V12H15.6134L15.2442 14.4083H13.3026V20.2325C17.2859 19.6075 20.3334 16.1583 20.3334 12C20.3334 7.39746 16.6026 3.66663 12.0001 3.66663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1797_28126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.5e3d15010ed9a145055aec5bd879f186.svg";
export { ForwardRef as ReactComponent };